import { axios } from '@/utils/request'

const api = {
  province: '/basicdata/province',
  city: '/basicdata/city',
  area: '/basicdata/area',
  street: '/basicdata/street',
}

export function getProvinceList (parameter) {
  return axios({
    url: api.province + '/list',
    method: 'get',
    params: parameter
  })
}

export function getProvinceUpdate (parameter) {
  return axios({
    url: api.province + '/update',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getProvinceSave (parameter) {
  return axios({
    url: api.province + '/save',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getCityList (parameter) {
  return axios({
    url: api.city + '/list',
    method: 'get',
    params: parameter
  })
}

export function getCitySave (parameter) {
  return axios({
    url: api.city + '/save',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getCityUpdate (parameter) {
  return axios({
    url: api.city + '/update',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getAreaList (parameter) {
  return axios({
    url: api.area + '/list',
    method: 'get',
    params: parameter
  })
}

export function getAreaSave (parameter) {
  return axios({
    url: api.area + '/save',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getAreaUpdate (parameter) {
  return axios({
    url: api.area + '/update',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getStreetList (parameter) {
  return axios({
    url: api.street + '/list',
    method: 'get',
    params: parameter
  })
}

export function getStreetSave (parameter) {
  return axios({
    url: api.street + '/save',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getStreetUpdate (parameter) {
  return axios({
    url: api.street + '/update',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//下拉
export function getSelectAllProvince (parameter) {
  return axios({
    url: api.province + '/selectAllProvince',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getelectCityName  (parameter) {
  return axios({
    url: api.city + '/selectCityName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getelectAreaName (parameter) {
  return axios({
    url: api.area + '/selectAreaName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//禁用1
export function getDisableProvince (parameter) {
  return axios({
    url: api.province + '/disableProvince',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//恢复1
export function getOpenProvince (parameter) {
  return axios({
    url: api.province + '/openProvince',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//禁用2
export function getDisableCity (parameter) {
  return axios({
    url: api.city + '/disableCity',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//恢复2
export function getOpenCity (parameter) {
  return axios({
    url: api.city + '/openCity',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//禁用3
export function getDisableArea (parameter) {
  return axios({
    url: api.area + '/disableArea',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//恢复3
export function getOpenArea (parameter) {
  return axios({
    url: api.area + '/openArea',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//禁用4
export function getDisableStreet (parameter) {
  return axios({
    url: api.street + '/disableStreet',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//恢复4
export function getOpenStreet (parameter) {
  return axios({
    url: api.street + '/openStreet',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export const fieldType = {
  '1': '1级',
  '2': '2级',
  '3': '3级',
  '4': '4级',
  '5': '5级',
}

export const accessoryExport = api.accessory + '/export'